export default "__VITE_ASSET__DaDMa7bc__"